import { httpWithAuth } from '~/clients';
import {
  GET_FAVORITES,
  ADD_FAVORITES,
  REMOVE_FAVORITES
} from '~/constants/endpoints';
import { logError, toError } from '~/utilities/errorHandlers';

export type FavoriteVehicle = {
  stockNumber: number;
  vehicleId: number;
  make: string;
  model: string;
  trim: string;
  mileage: number;
  price: {
    total: number;
    totalDiscountAmount: number;
  };
  year: number;
  imageUrl: string;
  vdpSlug: string;
  vehicleInventoryType: string;
  lockStatus: string;
  subscribeToWIPNotifications: boolean;
};

export type FavoriteRequestBody = {
  vehicleId: number;
  subscribeToWIPNotifications?: boolean;
};

type FavoriteResponse = {
  vehicles: FavoriteVehicle[] | [];
  hasHadFavorites: boolean;
};

export const fetchFavoritesApi = async (): Promise<
  FavoriteResponse | undefined
> => {
  try {
    const { data } = await httpWithAuth.get(GET_FAVORITES);

    return data;
  } catch (e) {
    logError(toError(e), { location: 'Get Favorites' });
  }

  return undefined;
};

export const addFavoriteApi = async (
  payload: FavoriteRequestBody
): Promise<FavoriteVehicle | null> => {
  try {
    const { data } = await httpWithAuth.post(ADD_FAVORITES, payload);

    return data ?? null;
  } catch (e) {
    logError(toError(e), { location: 'Add Favorite' });
  }

  return null;
};

export const removeFavoriteApi = async (payload: FavoriteRequestBody) => {
  try {
    await httpWithAuth.post(REMOVE_FAVORITES, payload);
  } catch (e) {
    logError(toError(e), { location: 'Remove Favorite' });
  }
};
